import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const OrderStage = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.MY_ORDER]: dependentFilterList?.orderStatusList
	};
	const onFetchData = async () => {
		let responseData = filterData[filterPageName] || [];
		responseData = responseData?.map((item) => {
			return { ...item, id: item.status, name: item.name.replace('_', ' ') };
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};

	return (
		<>
			<FilterName type="ORDER_STAGE" />
			<Checkbox data={data} type="ORDER_STAGE" handleSearch={handleSearch} />
		</>
	);
};

export default OrderStage;
